module.exports = __webpack_public_path__ + "img/res8.a8ea4381.gif";